import React from 'react'
import './Introduction.css';
import teleIcon from '../assets/tele-Icon.svg';
import GoldChart from '../plugins/GoldChart';
import GoldChartOut from '../plugins/GoldChartOut';
import OdoMeter from '../plugins/OdoMeter';
import missedIcon from '../assets/missedIcon.svg';
import tamilText from '../assets/tamil-text.svg';
import app_title from '../assets/app_title.svg';
import app_title2 from '../assets/app_title2.svg';
import ScreenSize from '../screen-size/ScreenSize';

const Introduction = () => {
  return (
   <>
      <div className="card intro-card">
         <img src={app_title2} alt="app_title" className='intro-title'/>
         <img src={app_title} alt="app_title2" className='intro-title2'/>
      </div>
      <div className='card-holder'>
        <OdoMeter/>
         <GoldChartOut/>
      </div>
      <ScreenSize/>
   </>
  )
}
export default Introduction
